import React, { useEffect, useState } from 'react';
import { showToast } from '../../services/toastifyservices';
import { handleSession } from '../../api/apiSessionHandle';
import { postaxiosRequestWithToken, getaxiosRequestWithToken, getPatientPool } from "../../api/api";
import CommonSpinner from '../../services/commonSpinner';
import SearchableSelect from '../../components/Medical-Program/SearchableSelect';
import PatientDetail from '../../components/Medical-Program/PatientDetails';
import { Modal, Spinner } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { PaginationControls } from "../../components/pagination"
import './assign-program.css';
import endpoints from '../../api/EndPoints';
const AssignProgram = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true); // Unified loading state
    const [medicalAssignProgram, setMedicalAssignProgram] = useState([]);
    const [selectedPateintPoolId, setselectedPateintPoolId] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [providers, setProviders] = useState([]);
    const [medicalProgram, setMedicalProgram] = useState([]);
    const [data, setData] = useState(null);
    const [SelectedRowRecord, setSelectedRowRecord] = useState(false);
    const [IsNew, setIsNew] = useState(false);


    //! Pagination state

    const [currentPage, setCurrentPage] = useState();
    const [rowsPerPage, setRowsPerPage] = useState();
    const [totalPages, setTotalPages] = useState();
    const pageCache = React.useRef({});

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await Promise.all([
                GetMedicalAssignProgram(),
                GetProvider(),
                GetMedicalProgram(),
            ]);
            setLoading(false);
        };
        fetchData();
    }, []);

    const handleInputChange = () => {
        setIsNew(true)
        setShowModal(true);
    };


    const GetProvider = async () => {
        try {
            const response = await getaxiosRequestWithToken(endpoints.FetchProvider);
            if (response.success) {
                setProviders(response.data.providers || []);
            }
        } catch (error) {
            handleError(error);
        }
    };

    const GetMedicalProgram = async () => {
        try {
            const response = await getaxiosRequestWithToken(endpoints.GetMedicalProgram);
            if (response.success) {
                setMedicalProgram(response.data.medical_programs || []);
            }
        } catch (error) {
            handleError(error);
        }
    };

    const GetMedicalAssignProgram = async () => {
        try {
            const endpoint = `assistant_api/fetch-medical-assigned-programs?page=1&status=active&limit=10`;
            const response = await getaxiosRequestWithToken(endpoint);
            if (response.success) {
                setMedicalAssignProgram(response.data.medical_programs.data || []);
                // setTotalPages(response.data.medical_programs.total)
                setRowsPerPage(response.data.medical_programs.per_page)
                setCurrentPage(response.data.medical_programs.current_page)
                setTotalPages(Math.ceil(response.data.medical_programs.total / response.data.medical_programs.per_page))

                console.log(response.data.medical_programs.total)
            }
        } catch (error) {
            handleError(error);
        }
    };

    const SaveData = async (data) => {
        setLoading(true);
        let endPoint = "";
        let payload = {};

        if (IsNew) {
            endPoint = "assign-medical-program";
            payload = {
                patient_pool_id: selectedPateintPoolId.toString(),
                medical_program_id: Number(data.medical_program_id),
                consent_sign_date: data.consent_sign_date,
                provider_id: data.provider_id,
                last_billing_date: data.last_billing_date,
            };
        } else {
            endPoint = "update-patient-medical-program";
            payload = {
                id: SelectedRowRecord.id,
                status: "active",
                medical_program_id: Number(data.medical_program_id),
                provider_id: String(data.provider_id),
                last_billing_date: data.last_billing_date,
            };
        }
        try {
            const response = await postaxiosRequestWithToken(endPoint, payload);
            if (response.success) {
                if (response.message == "Medical program added successfully.") {
                    showToast("error", response.message);
                    await GetMedicalAssignProgram();
                    setShowModal(false);
                } else {
                    showToast("success", response.message);
                }

            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };



    const handleError = (error) => {
        showToast("error", error.response?.data?.message || "Something went wrong.");
        handleSession(error.response?.data, navigate);
    };
    const handlePageChange = (page) => {

        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            fetchPatients(page);
        }
    };
    //! handle rows per page
    const handleRowsPerPageChange = (e) => {

        const newLimit = parseInt(e.target.value, 10);
        setRowsPerPage(newLimit);
        fetchPatients(currentPage, newLimit);
    };
    const fetchPatients = async (page, limit = rowsPerPage) => {

        if (pageCache.current[page]?.limit === limit) {
            const cachedData = pageCache.current[page];
            setMedicalAssignProgram(cachedData.data);
            setCurrentPage(cachedData.current_page);
            setTotalPages(cachedData.last_page);
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const response = await getPatientPool(page, limit);
            if (response) {
                
                const { data, current_page, last_page } = response.data.medical_programs;
                pageCache.current[page] = { data, current_page, last_page, limit };
                setMedicalAssignProgram(data);
                setCurrentPage(current_page);
                setTotalPages(last_page);
            }
        } catch (error) {
            
            handleSession(error.response?.data, navigate);
            console.error("Error fetching patients:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleRowClick = (rowData) => {
        var data = rowData
        setSelectedRowRecord(data)
        setselectedPateintPoolId(data.patient_pool_id)
        setIsNew(false)
        setShowModal(true)
    };


    return (
        <div className="mt-3 p-2 md:p-10 bg-gray-200">
            <div className="card">
                <span className="text-start font-bold ml-4 p-2 headingtext">Assign Medical Program</span>
            </div>
            <div className="card mt-2">
                <div className="d-flex justify-content-start p-3">
                    <label className="form-label font-bold mb-1 mt-2">
                        Search Patient:
                    </label>
                    <div className="col-md-4 position-relative ml-2" style={{ zIndex: 1050 }}>
                        <SearchableSelect
                            onChange={handleInputChange}
                            setSelectedValue={setselectedPateintPoolId}
                            styles={{ menu: (provided) => ({ ...provided, zIndex: 2000 }) }}
                        />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="table-container">
                    <table className="table table-striped table-hover">
                        <thead className="table-header">
                            <tr>
                                {/* <th>ID</th>
                                <th>Patient Pool ID</th>
                                <th>Medical Program ID</th> */}
                                {/* <th>Provider ID</th> */}

                                <th>Patient Name</th>

                                <th>Provider Name</th>
                                <th>Medical Program</th>
                                <th>Consent Sign Date</th>
                                <th>Last Billing Date</th>
                                <th>Status</th>


                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {loading ? (
                                ""
                            ) : medicalAssignProgram.length > 0 ? (
                                medicalAssignProgram.map((program, index) => (
                                    <tr key={index} >
                                        {/* <td>{program.id}</td>
                                        <td>{program.patient_pool_id}</td>
                                        <td>{program.medical_program_id}</td> */}
                                        {/* <td>{program.provider_id}</td> */}
                                        <td>{program.provider?.name}</td>

                                        <td>
                                            {program.patient_pool
                                                ? `${program.patient_pool.first_name} ${program.patient_pool.last_name}`
                                                : ""}
                                        </td>
                                        <td>{program.medical_program.name}</td>
                                        <td>{program.consent_sign_date}</td>
                                        <td>{program.last_billing_date}</td>
                                        <td>{program.status.charAt(0).toUpperCase() + program.status.slice(1)}</td>


                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {loading ? null : (
                    <div className="pagination-controls">
                        <PaginationControls
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => handlePageChange(page)}
                            rowsPerPage={rowsPerPage}
                            onLimitPerPage={handleRowsPerPageChange}
                        />
                    </div>
                )}
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                className="custom-modal-width"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Select Program</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <PatientDetail
                        patientPoolId={selectedPateintPoolId}
                        medicalProgram={medicalProgram}
                        providers={providers}
                        SubmitData={setData}
                        SaveData={SaveData}
                        loading={loading}
                        medicalProgramId={SelectedRowRecord.medical_program_id}
                        consentSignDate={SelectedRowRecord.consent_sign_date}
                        lastBillingDate={SelectedRowRecord.last_billing_date}
                        providerid={SelectedRowRecord.provider_id}
                        IsNew={IsNew}
                    />
                </Modal.Body>
            </Modal>
            {loading && <CommonSpinner />}
        </div>
    );
};

export default AssignProgram;
